export default __webpack_public_path__ + "static/media/quiz.a287d326.png";